module.exports = __webpack_public_path__ + "img/15.830bbea8.jpg";